import { render } from "./PMyFavorite.vue?vue&type=template&id=436ce43b&scoped=true"
import script from "./PMyFavorite.vue?vue&type=script&lang=js"
export * from "./PMyFavorite.vue?vue&type=script&lang=js"

import "./PMyFavorite.vue?vue&type=style&index=0&id=436ce43b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-436ce43b"]])

export default __exports__